






























































































import Vue from "vue";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import { archiveTeam, getOrgOverview, unarchiveTeam } from "@/helpers/api";
import { bus } from "@/main";
import Loading from "@/components/Loading.vue";

interface State {
  filter: string;
  showSearch: boolean;
  showActiveTeams: boolean;
  filteredTeams: any[];
  activeTeams: any[];
  archivedTeams: any[];
  loading: boolean;
}

export default Vue.extend({
  name: "SubscriptionLicenses",
  components: { Loading },
  props: {
    orgName: {
      type: String,
      required: true
    },
    orgId: {
      type: String,
      required: true
    }
  },
  data(): State {
    return {
      filter: "",
      showSearch: false,
      showActiveTeams: true,
      filteredTeams: [],
      activeTeams: [],
      archivedTeams: [],
      loading: true
    };
  },
  methods: {
    async toggleArchiveTeams() {
      this.showActiveTeams
        ? await this.archiveTeams()
        : await this.unarchiveTeams();
    },
    async unarchiveTeams() {
      this.loading = true;
      let archivedTeams = this.archivedTeams;
      let activeTeams = this.activeTeams;
      for (const t of this.selectedTeams) {
        await unarchiveTeam(t.id).then((res: any) => {
          archivedTeams = archivedTeams.filter((team: any) => t.id !== team.id);
          activeTeams = [...activeTeams, t];
        });
      }
      this.activeTeams = activeTeams;
      this.archivedTeams = archivedTeams;
      this.$emit("updateTeams", activeTeams.length);
      this.loading = false;
    },
    async archiveTeams() {
      this.loading = true;
      let archivedTeams = this.archivedTeams;
      let activeTeams = this.activeTeams;
      console.log(this.selectedTeams);
      for (const t of this.selectedTeams) {
        await archiveTeam(t.id).then((res: any) => {
          activeTeams = activeTeams.filter((team: any) => t.id !== team.id);
          archivedTeams = [...archivedTeams, t];
        });
      }
      this.activeTeams = activeTeams;
      this.archivedTeams = archivedTeams;
      this.$emit("updateTeams", activeTeams.length);
      this.loading = false;
    },
    close() {
      this.$emit("close");
    }
  },
  computed: {
    selectedTeams(): any[] {
      return this.filteredTeams.filter((t: any) => t.selected);
    }
  },
  async mounted() {
    const orgOverview = await getOrgOverview(this.orgId);
    this.activeTeams = orgOverview.teams
      .filter((t: any) => !t.archived)
      .map((t: any) => {
        return { ...t, selected: false };
      });
    this.archivedTeams = orgOverview.teams
      .filter((t: any) => t.archived)
      .map((t: any) => {
        return { ...t, selected: false };
      });
    this.loading = false;
  },
  watch: {
    showActiveTeams: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.showActiveTeams
          ? (this.filteredTeams = this.activeTeams.filter((t: any) =>
              t.name.toLowerCase().includes(this.filter)
            ))
          : (this.filteredTeams = this.archivedTeams.filter((t: any) =>
              t.name.toLowerCase().includes(this.filter)
            ));
      }
    },
    filter: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.showActiveTeams
          ? (this.filteredTeams = this.activeTeams.filter((t: any) =>
              t.name.toLowerCase().includes(this.filter)
            ))
          : (this.filteredTeams = this.archivedTeams.filter((t: any) =>
              t.name.toLowerCase().includes(this.filter)
            ));
      }
    },
    activeTeams: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.showActiveTeams
          ? (this.filteredTeams = this.activeTeams.filter((t: any) =>
              t.name.toLowerCase().includes(this.filter)
            ))
          : (this.filteredTeams = this.archivedTeams.filter((t: any) =>
              t.name.toLowerCase().includes(this.filter)
            ));
      }
    },
    archivedTeams: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.showActiveTeams
          ? (this.filteredTeams = this.activeTeams.filter((t: any) =>
              t.name.toLowerCase().includes(this.filter)
            ))
          : (this.filteredTeams = this.archivedTeams.filter((t: any) =>
              t.name.toLowerCase().includes(this.filter)
            ));
      }
    }
  }
});
